import { render, staticRenderFns } from "./RecentlyNotificationList.vue?vue&type=template&id=b88c9484&"
import script from "./RecentlyNotificationList.vue?vue&type=script&lang=js&"
export * from "./RecentlyNotificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports